var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"minH"},[_c('div',{staticClass:"nartL"},[_c('el-button',{staticClass:"declare",on:{"click":_vm.href}},[_vm._v("白、绿名单申报")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }